import { useMemo } from 'react'
import { GraphQL } from '@guestgoodie/graphql'

import { useFeatures } from './useFeatures'

export function useIsFeatureConnected(type: GraphQL.IntegrationTypes) {
  const features = useFeatures()

  return useMemo(() => {
    return features?.some(f => f.type === type && f.isSetupDone) ?? false
  }, [features, type])
}
